import React from 'react';
import shape from '../../assets/contact-items/contactShape.png';

const ContactShape = () => {
  return (
    <div className="contact-shape">
      <img src={shape} alt="contact-socials" />
    </div>
  );
};

export default ContactShape;
